var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input-autocomplete", {
    ref: "input",
    attrs: {
      disabled: _vm.disabled,
      fancy: _vm.fancy,
      icon: _vm.icon,
      "icon-left": _vm.iconLeft,
      "input-delay": 500,
      items: _vm.foundAddresses,
      label: _vm.label,
      open: true,
      "icon-left-tooltip": _vm.iconLeftTooltip,
      "icon-tooltip": _vm.iconTooltip,
      "empty-on-focus": "",
    },
    on: {
      blur: function ($event) {
        return _vm.onBlur()
      },
      focus: function ($event) {
        return _vm.onFocus()
      },
      "icon-click": function ($event) {
        return _vm.searchAddresses()
      },
      "icon-left-click": function ($event) {
        return _vm.iconLeftClick()
      },
      "item-click": function ($event) {
        return _vm.selectAddress($event)
      },
      keyup: function ($event) {
        return _vm.keyup($event)
      },
      "realtime-value": function ($event) {
        return _vm.onRealTimeValue($event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (p) {
          return [
            p.item.getDisplayedName() != ""
              ? _c("div", [
                  _vm._v(" " + _vm._s(p.item.getDisplayedName()) + " "),
                  p.item.FirstName || p.item.LastName
                    ? _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(p.item.CompanyName ? "(" : "") +
                            " " +
                            _vm._s(p.item.FirstName) +
                            " " +
                            _vm._s(p.item.LastName) +
                            " " +
                            _vm._s(p.item.CompanyName ? ")" : "") +
                            " "
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _c("div", { staticClass: "smaller" }, [
              _c("span", [_vm._v(_vm._s(p.item.AddressLine1))]),
            ]),
            _c("div", { staticClass: "smaller" }, [
              _c("span", [
                _vm._v(_vm._s(p.item.Postal) + " " + _vm._s(p.item.City)),
              ]),
            ]),
          ]
        },
      },
    ]),
    model: {
      value: _vm.input,
      callback: function ($$v) {
        _vm.input = $$v
      },
      expression: "input",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }